export var main_msg_pageNotFound = {
    key: 'page_not_found::main_msg_pageNotFound',
    fallback: "Page Not Found"
};
export var title_msg_likeToGo = {
    key: 'page_not_found::title_msg_likeToGo',
    fallback: "Where would you like to go?"
};
